module.exports = __webpack_public_path__ + "img/oaknest-8.725617eb.jpeg";